/**
 * lgk-trustpilot-reviews.js — Avis clients maison LeGeekShop
 */
(function () {
  function initCarousel(root) {
    if (!root || root.dataset.lgkTpReady === "true") return;
    root.dataset.lgkTpReady = "true";

    const track = root.querySelector("[data-lgk-tp-track]");
    const slides = Array.from(root.querySelectorAll("[data-lgk-tp-slide]"));
    const prev = root.querySelector("[data-lgk-tp-prev]");
    const next = root.querySelector("[data-lgk-tp-next]");
    const dotsContainer = root.querySelector("[data-lgk-tp-dots]");
    let dots = Array.from(root.querySelectorAll("[data-lgk-tp-dot]"));
    const autoplayMs = parseInt(root.dataset.autoplay || "0", 10);

    if (!track || slides.length === 0) return;

    let index = 0;
    let timer = null;
    let perView = 1;

    function buildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = "";
      const count = maxIndex() + 1;
      if (count <= 1) return;
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "lgk-tp-carousel__dot";
        dot.setAttribute("data-lgk-tp-dot", "");
        dot.setAttribute("aria-label", `Avis ${i + 1}`);
        dot.addEventListener("click", () => {
          goTo(i);
          startAutoplay();
        });
        dotsContainer.appendChild(dot);
      }
      dots = Array.from(dotsContainer.querySelectorAll("[data-lgk-tp-dot]"));
    }

    function getPerView() {
      const attr = parseInt(root.dataset.perView || "1", 10);
      if (window.matchMedia("(min-width: 1100px)").matches) return Math.min(attr, slides.length);
      if (window.matchMedia("(min-width: 900px)").matches) return Math.min(Math.max(1, attr - 1), slides.length);
      if (window.matchMedia("(min-width: 700px)").matches) return Math.min(2, slides.length);
      return 1;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView);
    }

    function goTo(i) {
      index = Math.max(0, Math.min(i, maxIndex()));
      const offset = (index * 100) / perView;
      track.style.transform = `translate3d(-${offset}%, 0, 0)`;
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute("aria-current", dotIndex === index ? "true" : "false");
      });
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
    }

    function nextSlide() {
      goTo(index >= maxIndex() ? 0 : index + 1);
    }

    function startAutoplay() {
      if (!autoplayMs || slides.length <= perView) return;
      stopAutoplay();
      timer = window.setInterval(nextSlide, autoplayMs);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function refresh() {
      perView = getPerView();
      buildDots();
      goTo(Math.min(index, maxIndex()));
    }

    prev?.addEventListener("click", () => {
      goTo(index - 1);
      startAutoplay();
    });
    next?.addEventListener("click", () => {
      goTo(index + 1);
      startAutoplay();
    });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", startAutoplay);

    let touchStartX = 0;
    root.addEventListener(
      "touchstart",
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoplay();
      },
      { passive: true }
    );
    root.addEventListener(
      "touchend",
      (e) => {
        const delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) > 40) goTo(delta > 0 ? index - 1 : index + 1);
        startAutoplay();
      },
      { passive: true }
    );

    window.addEventListener("resize", refresh, { passive: true });
    refresh();
    startAutoplay();
  }

  function initReviewList(root) {
    if (!root || root.dataset.lgkTpListReady === "true") return;
    root.dataset.lgkTpListReady = "true";

    const items = Array.from(root.querySelectorAll("[data-lgk-tp-list-item]"));
    const perPage = parseInt(root.dataset.perPage || "15", 10);
    const prev = root.querySelector("[data-lgk-tp-list-prev]");
    const next = root.querySelector("[data-lgk-tp-list-next]");
    const info = root.querySelector("[data-lgk-tp-list-info]");

    if (items.length <= perPage) return;

    let page = 0;
    const totalPages = Math.ceil(items.length / perPage);

    function render() {
      items.forEach((item, i) => {
        item.hidden = !(i >= page * perPage && i < (page + 1) * perPage);
      });
      if (info) info.textContent = `${page + 1} / ${totalPages}`;
      if (prev) prev.disabled = page <= 0;
      if (next) next.disabled = page >= totalPages - 1;
    }

    prev?.addEventListener("click", () => {
      if (page > 0) {
        page -= 1;
        render();
      }
    });
    next?.addEventListener("click", () => {
      if (page < totalPages - 1) {
        page += 1;
        render();
      }
    });

    render();
  }

  function boot() {
    document.querySelectorAll("[data-lgk-tp-carousel]").forEach(initCarousel);
    document.querySelectorAll("[data-lgk-tp-list]").forEach(initReviewList);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-lgk-tp-carousel]").forEach(initCarousel);
    event.target.querySelectorAll("[data-lgk-tp-list]").forEach(initReviewList);
  });
})();
